const PMO_TYPES_TEXT = "PMO Type(s)"

export {
  PMO_TYPES_TEXT,
}